const actions = {
  SET_STATE: 'apiLoader/SET_STATE',
}

export default actions
